import { calendarBookedDays } from '@uplift/api';
import { DateFormats } from '@uplift/constants';
import { CalendarDateService } from '@uplift/services';
import React from 'react';
import { useQuery } from '@tanstack/react-query';


export const useBookedDays = (monthDate: string, timezone: string) => {
  const range = React.useMemo(() => {
    const date = CalendarDateService.date(monthDate, DateFormats.ISO_DATE).tz(timezone);
    const start = date.subtract(1, 'month').startOf('month').utc().format();
    const end = date.add(1, 'month').endOf('month').utc().format();

    return { start, end };
  }, [ monthDate, timezone ]);

  const { data } = useQuery([ 'calendar', 'booked-days', range.start, range.end ], async () => {
    return calendarBookedDays({
      datetime_from: range.start,
      datetime_to: range.end,
    });
  }, {
    keepPreviousData: true,
    staleTime: Infinity,
  });

  return data;
};
